export  const Years = () =>{
    const date = new Date()
    const latestYear = date.getFullYear()
    const yearsList =[]
for (let i=1990; i <= latestYear + 10; i++){
    yearsList.push(i)
}
return yearsList;
}
export const ExperienceYears = () => {
    const year = ['less than a year', '1 -2 years', '2 - 5 years', 'more than 5 years']
    return year
}